<template>
  <div>
    <div class="row" style="width: 100%;">
      <div class="col-sm-5">
        <div class="row">
          <div class="col-6 text-left">
            <b class="minihead">BENEFICIARIO</b>
          </div>
          <div class="col-6 text-right">
            <span class="badge badge-primary" style="font-size:1.1rem !important;font-weight:600;">{{ deliveryType }}</span>
          </div>
        </div>
        <table>
          <tr>
            <td class="text-left">
              <b>Nombre:</b>
            </td>
            <td class="text-left">{{ currentOrder.client }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Teléfono:</b>
            </td>
            <td class="text-left">{{ currentOrder.service_route.point_b.mobile_number }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Provincia:</b>
            </td>
            <td class="text-left">{{ currentOrder.service_route.point_b.province }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Dirección:</b>
            </td>
            <td class="text-left">{{ currentOrder.service_route.point_b.dir }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Referencia:</b>
            </td>
            <td class="text-left">{{ currentOrder.service_route.point_b.reference }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Quien recibe:</b>
            </td>
            <td class="text-left">{{ currentOrder.service_route.point_b.name || '' }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Fecha:</b>
            </td>
            <td class="text-left">{{ currentOrder.confirmation_date || currentOrder.date }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Tipo entrega:</b>
            </td>
            <td class="text-left">{{ deliveryType }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Fecha {{ currentOrder.pickup ? 'de recojida' : 'de entrega' }}</b>
            </td>
            <td class="text-left">{{ currentOrder.schedule_order }}</td>
          </tr>
        </table>
        <br />
        <b v-if="$userIsAdmin()" class="minihead">PAGO</b>
        <table v-if="$userIsAdmin()">
          <tr>
            <td class="text-left">
              <b>Forma de pago:</b>
            </td>
            <td class="text-left">{{ currentOrder.payment_type == 1 ? 'Transferencia' : 'Tarjeta' }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Proveedor:</b>
            </td>
            <td class="text-left">{{ currentOrder.payment_provider || '--' }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>No. de transacción:</b>
            </td>
            <td class="text-left">{{ currentOrder.transaction_id || '' }}</td>
          </tr>
        </table>
        <br />
        <hr />
        <table>
          <tr>
            <td class="text-left">
              <b>Subtotal:</b>
            </td>
            <td
              class="text-rigth"
            >&nbsp;&nbsp;{{ currentOrder.suplierCurrency }}${{ $helpers.asMoney(currentOrder.sub_total) }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Proveedor:</b>
            </td>
            <td
              class="text-rigth"
            >&nbsp;&nbsp;{{ currentOrder.suplierCurrency }}${{ $helpers.asMoney(currentOrder.taxes || 0) }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Envío:</b>
            </td>
            <td
              class="text-rigth"
            >&nbsp;&nbsp;{{ currentOrder.suplierCurrency }}${{ $helpers.asMoney(currentOrder.shipping_cost || 0) }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>Cargo de Servicio:</b>
            </td>
            <td
              class="text-rigth"
            >&nbsp;&nbsp;{{ currentOrder.suplierCurrency }}${{ $helpers.asMoney(currentOrder.service_fee_calculated ? (currentOrder.service_fee || 0) : 0) }}</td>
          </tr>
          <tr v-if="currentOrder.applied_coupon">
            <td class="text-left">
              <b>Descuento por cupón:</b>
            </td>
            <td
              class="text-rigth"
            >&nbsp;&nbsp;{{ currentOrder.suplierCurrency }}${{ $helpers.asMoney(currentOrder.invoice_info.total_in_coupon || 0) }}</td>
          </tr>
          
          <tr>
            <td class="text-left">
              <b class="main-green">Total a pagar:</b>
            </td>
            <td class="text-rigth">
              &nbsp;&nbsp;
              <b>{{ currentOrder.suplierCurrency }}${{ $helpers.asMoney(currentOrder.total) }}</b>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-sm-7">
        <b class="minihead">PRODUCTOS ({{ orderProducts.length }})</b>
        <div style="overflow-y:auto;max-height:395px;">

          <!-- LISTA DE PRODUCTOS Y CANASTAS -->
          <ul class="list-group">
            <li class="list-group-item" v-for="product in orderProducts" :key="product.id">
              <div class="row">

                <div class="col-6 text-left" style="display: flex;">
                  <div v-if="!product.isBasket">
                    <img :src="product.photo" :alt="product.name" class="basket-product-photo mr-1">
                  </div>
                  <span>
                    <b v-if="product.isBasket" class="main-green">
                      {{ product.name }}
                    </b>
                    <span v-else>{{ product.name }}</span>
                  </span>
                </div>

                <div v-if="!product.isBasket" class="col-2 text-center">{{ product.quantity }}</div>
                <div v-if="!product.isBasket" class="col-2 text-center">${{ product.price | money }}</div>
                <div v-if="!product.isBasket" class="col-2 text-center">${{ product.total | money }}</div>

              </div>
              <div v-if="product.isBasket" >
                <!-- PRODUCTOS DE LA CANASTA -->
                <div class="row"
                  v-for="basketProduct in product.products" 
                  :key="basketProduct.id">

                  <div class="col-6 text-left" style="display: flex;padding-left: 23px;">
                    <img :src="basketProduct.photo" :alt="product.name" class="basket-product-photo mr-1">
                    <span>{{ basketProduct.name }}</span>
                  </div>

                  <div class="col-2 text-center">{{ basketProduct.quantity }}</div>
                  <div class="col-2 text-center">${{ basketProduct.price | money }}</div>
                  <div class="col-2 text-center">${{ Number((basketProduct.quantity * basketProduct.price).toFixed(2)) | money }}</div>
                  
                </div>
              </div>
            </li>
          </ul>

        </div>
        <div class="card">
          <div class="card-body">
            <b>Nota:</b>
            <p>{{ currentOrder.note }}</p>
          </div>
        </div>
        <p v-if="currentOrder.cancel_reason">Razón de cancelación: <span class="text-danger">{{ currentOrder.cancel_reason }}</span></p>
      </div>
    </div>

    <OverlayLoading :loading="gettingBasketProducts"/>
  </div>
</template>

<script>
import OverlayLoading from "./OverlayLoading";

export default {
  name: "OrderDetailModalContent",
  props: ["currentOrder", "orderProducts"],
  components: {OverlayLoading},
  data: function () {
    return {
      categoriesCache: [],
      currentBasketProducts: [],
      gettingBasketProducts: false,
      currentBasketName: ''
    };
  },
  methods: {
  },
  computed: {
    deliveryType(){
      // This behavior is only for Farmacia Carol
      if(this.currentOrder.companyId === 'farmacia_carol@domi.com'){
        return this.currentOrder.pickup ? 'Delivery' : 'Pickup';
      }
      return this.currentOrder.pickup ? 'Pickup' : 'Delivery';
    }
    
  }
};
</script>
<style lang="scss" scoped>
.modal-body table {
  tr > td {
    font-weight: 500;
  }
}
.minihead {
  font-size: medium;
}
.basket-product-photo{
  max-height: 60px;
  max-width: auto;
}
.basket-products-modal-content{
  max-height:400px; 
  overflow-y:auto;
}
.list-group {
  text-transform:none;
  font-size: 13px !important;
}
</style>